import { styled } from "styled-components";

interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
}
export const WrapperButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  padding-right: 10px;
`;
export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  padding: 10px;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    box-shadow: 0px 0px 4px black;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;

export const WrapperCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  padding: 2rem 2rem;
  @media (max-width: 426px) {
    gap: 20px;
    padding: 0 0 10px 0;
  }
`;

export const TextModal = styled.h2`
  color: #2c2c2c;
  text-align: center;
  padding: 12px;
  margin-bottom: 15px;
  @media (max-width: 426px) {
    font-size: 22px;
    margin-bottom: 15px;
  }
`;
export const RequiredMessage = styled.span`
  padding: 0;
  color: red;
  font-size: 12px;
`;
